import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";
import popupAsset from "@/assets/tishrei-hours-popup.jpg.asset.json";

// Auto-hides from this date onward.
const EXPIRES_AT = new Date("2026-09-28T00:00:00+03:00").getTime();
const STORAGE_KEY = "cavalli:hours-notice-count";
const MAX_SHOWS = 3;
const DELAY_MS = 5000;

const getCount = () => {
  const v = sessionStorage.getItem(STORAGE_KEY);
  return v ? parseInt(v, 10) : 0;
};

const bumpCount = () => {
  sessionStorage.setItem(STORAGE_KEY, String(getCount() + 1));
};

const HoursNoticePopup = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (Date.now() >= EXPIRES_AT) return;
    if (getCount() >= MAX_SHOWS) return;

    const t = setTimeout(() => {
      bumpCount();
      setOpen(true);
    }, DELAY_MS);
    return () => clearTimeout(t);
  }, [location.pathname]);

  const close = () => setOpen(false);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[9998] flex items-center justify-center bg-black/70 backdrop-blur-sm animate-fade-in p-4"
      role="dialog"
      aria-modal="true"
      aria-label="שעות הפעילות בחגי תשרי"
      onClick={close}
    >
      <div
        className="relative max-w-[92vw] max-h-[92vh] md:max-w-[600px] md:max-h-[85vh]"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={close}
          aria-label="סגור"
          className="absolute top-2 z-10 w-10 h-10 rounded-full bg-background/90 border border-primary/50 text-primary flex items-center justify-center shadow-lg hover:scale-105 transition-transform"
          style={{ right: "0.5rem", left: "auto" }}
        >
          <X className="w-5 h-5" />
        </button>
        <img
          src={popupAsset.url}
          alt="שעות הפעילות של קפה קוואלי בחגי תשרי"
          className="block max-w-full max-h-[92vh] md:max-h-[85vh] w-auto h-auto rounded-lg shadow-2xl"
          loading="eager"
          decoding="async"
        />
      </div>
    </div>
  );
};

export default HoursNoticePopup;
